import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';

const useGetSiteDocs = siteAssessmentID => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const fetchDocs = async () => {
    setLoading(true);
    try {
      const response = await customAxios.get('/CRM/GetCRMSiteDetailsDocs', {
        headers: authHeader(),
        params: { siteAssessmentID },
      });
      console.log('[Docs API]', response.data);
      setDocs(response.data || []);
    } catch (err) {
      console.error('Failed to fetch docs:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!siteAssessmentID) return;

    let isMounted = true;

    const fetchDocs = async () => {
      setLoading(true);
      try {
        const response = await customAxios.get('/CRM/GetCRMSiteDetailsDocs', {
          headers: authHeader(),
          params: { siteAssessmentID },
        });
        console.log('[Docs API]', response.data);
        if (isMounted) {
          setDocs(response.data || []);
        }
      } catch (err) {
        console.error('Failed to fetch docs:', err);
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchDocs();

    return () => {
      isMounted = false;
    };
  }, [siteAssessmentID]);

  const viewSiteDoc = fileData => {
    dispatch({ type: FETCH_START });
    console.log(fileData);
    const url = `/CRM/GetCRMSiteDetailsFile?id=${fileData.id}`;
    customAxios
      .get(url, { headers: authHeader(), responseType: 'blob' })
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob.data);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileData.documentName || 'download';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: 'Could not fetch document' });
      });
  };

  return { docs, loading, error, refetch: fetchDocs, viewSiteDoc };
};

export default useGetSiteDocs;
